import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-line-break',
  templateUrl: './formly-line-break.component.html',
  styleUrl: './formly-line-break.component.scss',
})
export class FormlyLineBreakComponent extends FieldType {}
